import styled from 'styled-components';
import { Skeleton } from 'ui/skeleton';
import { spacing } from 'ui/theme';

export const StyledSkeletonContainer = styled.div`
  padding-bottom: ${spacing.plusHalf};
  margin: ${spacing.plusHalf} ${spacing.plusHalf} 0 ${spacing.plusHalf};
`;

export const ContributintFactorsSkeletonId = 'contributing-factors-skeleton';

export const ContributingFactorsSkeleton = () => {
  return (
    <StyledSkeletonContainer>
      <Skeleton data-test={ContributintFactorsSkeletonId} height={500} />
    </StyledSkeletonContainer>
  );
};
